import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

// import Breadcrumbs from '../../components/BreadCrumbs'
import Header from '../../components/Header'
import Sidebar from '../../components/Sidebar'
import TabMenu from '../../components/TabMenu'
import useAuth from '../../hooks/api/useAuth'

function DashboardFrame() {
  const { chechCurrentAuthUser } = useAuth()
  const navigate = useNavigate()

  const handleNavigate = () => {
    if (!chechCurrentAuthUser()) {
      navigate('/login')
    }
  }

  useEffect(() => {
    handleNavigate()
    window.addEventListener('focus', handleNavigate)
    return () => {
      window.removeEventListener('focus', handleNavigate)
    }
  })

  return (
    <div className='flex flex-col w-screen h-screen overflow-auto'>
      <Header />
      <div className='flex flex-grow'>
        <Sidebar />
        <div className='grow flex flex-col bg-[#fff] pt-4 px-8 pb-8 gap-4'>
          <TabMenu />
        </div>
      </div>
    </div>
  )
}

export default DashboardFrame
